import Vue from 'vue';
import axios from 'axios';
import Slick from 'vue-slick';

// Filters
import './filters/currencyFromCents';
import './filters/replace';

// Single file components
import MaCode from './components/ma-code.vue';

// Components with inline templates
import './components/search-bar';
import './components/newsletter';
import './components/look-book';
import './components/collection-page';
import './components/product';

function initVueInstance() {
    new Vue({
        el: '#app',
        
        delimiters: ['${', '}'],

        components: {
            Slick,
            MaCode
        },

        data: {
            isMenuOpen: false,
            isMinicartOpen: false,
            cart: false
        },

        created() {
            axios.get('/cart.js').then((response) => {
                // console.log('minicart', response.data);
                this.cart = response.data;

            }).catch((error) => {
                console.log(error);
            });
        },

        methods: {
            toggleMenu() {
                this.isMenuOpen = !this.isMenuOpen;
                this.isMinicartOpen = false;

                if (this.isMenuOpen) {
                    document.querySelector('body').classList.add('no-scroll');
                } else {
                    document.querySelector('body').classList.remove('no-scroll');
                }
            },

            toggleMinicart() {
                this.isMinicartOpen = !this.isMinicartOpen;
                this.isMenuOpen = false;
            },

            removeItem(item, index) {
                // console.log('item', item, index);
                item.isLoading = true;
                Vue.set(this.cart.items, index, item);

                let data = {
                    [item.id]: 0
                };
                // console.log('reduced', data);

                axios.post('/cart/update.js', { updates: data }).then((response) => {
                    // console.log('response', response.data);
                    this.cart = response.data;
                
                }).catch((error) => {
                    console.log(error);
                    item.isLoading = false;
                });
            },

            addToCart(variantId) {
                // console.log('variantId', variantId);
                if (!variantId) return;

                // this.isMinicartOpen = true;

                let data = {
                    [variantId]: 1
                };
                
                let cartItem = this.cart.items.find(item => item.variant_id == variantId);
                if (cartItem) {
                    data[variantId] = cartItem.quantity + 1;        
                }
                // console.log('data', data);

                return axios.post('/cart/update.js', { updates: data } ).then((response) => {
                    // console.log('response', response.data);
                    this.cart = response.data;
                    return response.data;
                
                }).catch((error) => {
                    console.log(error);
                    throw error;
                });
            }
        }
    });
}

/*
* Workaround for issue when Vue wraps the index template, admin cannot configure dynamic 
* sections from the theme customizer.
* All elements with v-if or v-show directives will be hidden by default, add the attribute 
* "shopify-design-mode-show" to force show.
* TODO: refactor to only apply to index template
*/
let path = window.location.pathname.split('/');
let isChallengePage = path.length > 1 && path[1] == 'challenge';

if (!Shopify.designMode && !isChallengePage) {
    document.querySelectorAll('script:not([type]), script[type="text/javascript"]').forEach((script) => { 
        document.querySelector('body').appendChild(script);
    });

    initVueInstance();

} else {
    document.querySelector('body').classList.add('vue-disabled');

    if (isChallengePage) {
        document.querySelectorAll('[\\@click]').forEach((element) => {
            element.addEventListener('click', () => {
                window.location.href = '/';
            });
        });

    } else {
        document.querySelectorAll('[\\@click]').forEach((element) => {
            element.addEventListener('click', () => {
                alert('This functionality has been disabled in the editor.');
            });
        });
    }
}